import { IModel } from '@/@types/models/model';
import coreFields from './helpers/coreFields';
import commonFields from './helpers/commonFields';

const ThreeDSettings: IModel = {
  title: '3D Settings',
  apiPath: 'system/3d_settings',
  forms: {
    insert: {
      fields: [{ source: 'tenant_id', readonly: false }, 'model_names', 'cesium_folder', 'cesium_config_file', 'level_of_detail', 'geom'],
    },
    update: {
      fields: ['id', { source: 'tenant_id', readonly: false }, 'model_names', 'cesium_folder', 'cesium_config_file', 'level_of_detail', 'geom'],
    },
    search: {
      fields: ['cesium_folder', 'cesium_config_file', 'tenant_id'],
    },
  },
  listViews: {
    default: {
      fields: ['id', 'tenant_id', 'model_names', 'cesium_folder', 'cesium_config_file', 'level_of_detail'],
    },
  },
  fields: [
    coreFields.id,
    {
      title: 'cesium_folder',
      source: 'cesium_folder',
      ttoken: 'admin:3d.cesium_folder',
      type: 'text',
      filter: true,
      validation: {
        required: true,
        maxLength: 512,
      },
    },
    {
      title: 'cesium_config_file',
      source: 'cesium_config_file',
      ttoken: 'admin:3d.cesium_config_file',
      type: 'text',
      filter: true,
      validation: {
        required: true,
        maxLength: 512,
      },
    },
    {
      title: 'tenant_id',
      source: 'tenant_id',
      ttoken: 'admin:common.tenant_id',
      type: 'picker',
      subModel: {
        apiPath: 'system/tenants?view=picker',
        format: '{label}',
        idattr: 'id',
      },
      readonly: true,
      validation: {
        required: true,
      },
      filter: true,
    },
    {
      title: 'model_names',
      source: 'model_names',
      ttoken: 'admin:3d.model_names',
      type: 'text',
      filter: true,
      validation: {
        maxLength: 512,
      },
    },
    {
      title: 'level_of_detail',
      source: 'level_of_detail',
      ttoken: 'admin:3d.level_of_detail',
      type: 'text',
      filter: true,
    },
    { ...coreFields.geom, sourceProjection: 'EPSG:4326' },
    commonFields.wkt,
  ],
};

export default ThreeDSettings;
